module.exports = __webpack_public_path__ + "static/media/nob.5077cd50.png";